import { format, isValid, parseISO } from 'date-fns';

export const DISPLAY_DATE_FORMAT = 'MM-dd-yy';
export const DISPLAY_DATE_TIME_FORMAT = `${DISPLAY_DATE_FORMAT} HH:mm:ss`;
export const DATE_PICKER_VALUE_FORMAT = 'MM-DD-YY';

type DateValue = Date | string | null | undefined;

function parseDateValue(value: DateValue): Date | null {
  if (!value) {
    return null;
  }

  const date = value instanceof Date ? value : parseISO(value);
  return isValid(date) ? date : null;
}

export function formatDisplayDate(
  value: DateValue,
  fallback = '-'
): string {
  const date = parseDateValue(value);
  return date ? format(date, DISPLAY_DATE_FORMAT) : fallback;
}

export function formatDisplayDateTime(
  value: DateValue,
  fallback = '-'
): string {
  const date = parseDateValue(value);
  return date ? format(date, DISPLAY_DATE_TIME_FORMAT) : fallback;
}
